var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "modal-dialog modal-fullscreen text-light" },
    [
      _c("div", { staticClass: "modal-content bg-transparent border-0" }, [
        _c("div", { staticClass: "modal-header border-0" }, [
          _c("button", {
            staticClass: "btn-close btn-close-white fs-4 opacity-100",
            attrs: { "aria-label": "Close", type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("hide-modal")
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal-body d-flex align-items-center text-center",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.$emit("hide-modal")
              },
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-link fs-1 text-light p-4",
                class: { invisible: _setup.itemIndex <= 0 },
                attrs: { type: "button" },
                on: { click: _setup.showPrevious },
              },
              [_c("i", { staticClass: "bi-chevron-left" })]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex-fill px-3" }, [
              _setup.currentItem
                ? _c("img", {
                    staticClass: "shadow img-fluid mw-100 mh-100",
                    attrs: {
                      alt: _setup.currentItem.title,
                      src: _setup.currentItem.src,
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-link fs-1 text-light p-4",
                class: {
                  invisible: _setup.itemIndex >= _setup.items.length - 1,
                },
                attrs: { type: "button" },
                on: { click: _setup.showNext },
              },
              [_c("i", { staticClass: "bi-chevron-right" })]
            ),
          ]
        ),
        _vm._v(" "),
        _setup.currentItem
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center px-4 py-3 fs-6 text-light bg-dark bg-opacity-25",
              },
              [
                _c("p", { staticClass: "flex-fill mb-0" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_setup.currentItem.title) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "count mb-0" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_setup.itemIndex + 1) +
                      " of " +
                      _vm._s(_setup.items.length) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }